export const teamLogo = (id) =>
    id ? `https://media.api-sports.io/football/teams/${id}.png` : "";
export const leagueLogo = (id) =>
    id ? `https://media.api-sports.io/football/leagues/${id}.png` : "";
export const isFinished = (s) => ["FT", "AET", "PEN"].includes(s ?? "");
export const fmt = (iso) => new Date(iso).toLocaleString();
